import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gaokao-detail-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-header__left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "page-header__right" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "filter-panel" }
const _hoisted_8 = {
  key: 1,
  class: "question-list"
}
const _hoisted_9 = { class: "question-item__head" }
const _hoisted_10 = { class: "question-item__number" }
const _hoisted_11 = {
  key: 4,
  class: "question-item__pages"
}
const _hoisted_12 = {
  key: 1,
  class: "question-item__empty"
}
const _hoisted_13 = {
  key: 2,
  class: "question-item__options"
}
const _hoisted_14 = {
  key: 3,
  class: "question-item__answer"
}
const _hoisted_15 = {
  key: 4,
  class: "question-item__images"
}

import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { ArrowLeftOutlined } from "@ant-design/icons-vue";
import MarkdownContent from "@/components/MarkdownContent.vue";
import {
  getGaokaoPaperDetailApi,
  getGaokaoPaperQuestionsApi,
} from "@/servers/api/papers";

type PaperDetail = {
  id: number;
  name: string;
  subject: string;
  year: string;
  question_count?: number;
  missing_count?: number;
};

type QuestionItem = {
  id: number;
  string_number: string;
  question_type?: string;
  content?: string;
  options?: Record<string, any> | string[] | null;
  answer?: string;
  score?: number;
  image_urls?: string[];
  pages?: number[];
  status?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'GaokaoPaperDetail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const paperId = Number(route.params.paperId);

const statusOptions = [
  { label: "已解析", value: "parsed" },
  { label: "待补录", value: "missing" },
  { label: "已校对", value: "edited" },
];

const loading = ref(false);
const paper = ref<PaperDetail | null>(null);
const questions = ref<QuestionItem[]>([]);
const statusFilter = ref<string | undefined>(undefined);

const visibleQuestions = computed(() => questions.value);

const isSuccess = (response?: { code?: number }) =>
  response?.code === undefined || response?.code === 0 || response?.code === 200;

const optionList = (question: QuestionItem): string[] => {
  const value = question.options;
  if (Array.isArray(value)) return value as string[];
  if (value && typeof value === "object") return Object.values(value) as string[];
  return [];
};

const loadPaper = async () => {
  try {
    const response = await getGaokaoPaperDetailApi({ paper_id: paperId });
    if (!isSuccess(response)) {
      message.error(response?.msg || "获取试卷信息失败");
      return;
    }
    paper.value = (response?.data as PaperDetail) ?? null;
  } catch (error: any) {
    message.error(error?.message || "获取试卷信息失败");
  }
};

const loadQuestions = async () => {
  loading.value = true;
  try {
    const response = await getGaokaoPaperQuestionsApi({
      paper_id: paperId,
      status: statusFilter.value || undefined,
      page: 1,
      size: 200,
    });
    if (!isSuccess(response)) {
      message.error(response?.msg || "获取题目失败");
      return;
    }
    questions.value = (response?.data as QuestionItem[]) || [];
  } catch (error: any) {
    message.error(error?.message || "获取题目失败");
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  router.push("/gaokao_question_bank");
};

onMounted(() => {
  loadPaper();
  loadQuestions();
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "text",
          class: "back-btn",
          onClick: goBack
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeftOutlined)),
            _cache[1] || (_cache[1] = _createTextVNode(" 返回 ", -1))
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(paper.value?.name || "试卷详情"), 1),
          (paper.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _createVNode(_component_a_tag, { color: "blue" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(paper.value.year) + " 年", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tag, { color: "green" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(paper.value.subject), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tag, null, {
                  default: _withCtx(() => [
                    _createTextVNode("共 " + _toDisplayString(paper.value.question_count ?? questions.value.length) + " 题", 1)
                  ]),
                  _: 1
                }),
                (paper.value.missing_count)
                  ? (_openBlock(), _createBlock(_component_a_tag, {
                      key: 0,
                      color: "red"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(paper.value.missing_count) + " 题待补录", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (paper.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: `/api/gaokao/papers/files/${paper.value.id}/`,
              target: "_blank",
              rel: "noopener"
            }, "下载原卷", 8, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createVNode(_component_a_select, {
        value: statusFilter.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((statusFilter).value = $event)),
        placeholder: "题目状态",
        options: statusOptions,
        "allow-clear": "",
        style: {"width":"160px"},
        onChange: loadQuestions
      }, null, 8, ["value"])
    ]),
    _createVNode(_component_a_spin, { spinning: loading.value }, {
      default: _withCtx(() => [
        (!loading.value && visibleQuestions.value.length === 0)
          ? (_openBlock(), _createBlock(_component_a_empty, {
              key: 0,
              description: "该试卷暂无题目"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleQuestions.value, (question) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: question.id,
                  class: "question-item"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, "第 " + _toDisplayString(question.string_number) + " 题", 1),
                    (question.question_type)
                      ? (_openBlock(), _createBlock(_component_a_tag, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(question.question_type), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (question.score)
                      ? (_openBlock(), _createBlock(_component_a_tag, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(question.score) + " 分", 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (question.status === 'missing')
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 2,
                          color: "red"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("待补录", -1)
                          ]))]),
                          _: 1
                        }))
                      : (question.status === 'edited')
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 3,
                            color: "orange"
                          }, {
                            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                              _createTextVNode("已校对", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                    (question.pages?.length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " 第 " + _toDisplayString(question.pages.join("、")) + " 页 ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  (question.content)
                    ? (_openBlock(), _createBlock(MarkdownContent, {
                        key: 0,
                        content: question.content,
                        class: "question-item__content"
                      }, null, 8, ["content"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, "该题内容待补录，可查看下方原卷裁图。")),
                  (optionList(question).length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionList(question), (option, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            _createVNode(MarkdownContent, { content: option }, null, 8, ["content"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (question.answer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "question-item__answer-label" }, "答案", -1)),
                        _createVNode(MarkdownContent, {
                          content: question.answer
                        }, null, 8, ["content"])
                      ]))
                    : _createCommentVNode("", true),
                  (question.image_urls?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_a_image_preview_group, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.image_urls, (url) => {
                              return (_openBlock(), _createBlock(_component_a_image, {
                                key: url,
                                src: url,
                                width: 220,
                                class: "question-item__image"
                              }, null, 8, ["src"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}
}

})